<template>
    <Transition
        name="fade"
        mode="out-in"
    >
        <div
            v-show="isLoaded"
            class="Profile"
        >
            <PageTitle>{{ $t('personal-account.profile.title') }}</PageTitle>
            <!--        <div class="Profile-progressBar">-->
            <!--            <ProgressBar-->
            <!--                :percent="percent"-->
            <!--                :label="`Profile completion: ${percent}%`"-->
            <!--            />-->
            <!--        </div>-->
            <!--        <div class="Profile-serviceAvailability">-->
            <!--            <ServiceAvailability :services="services" />-->
            <!--        </div>-->
            <div class="Profile-personalInfoContainer">
                <Block
                    v-if="profile"
                    class="Profile-personalInfoContainerBlock"
                >
                    <h3
                        class="Profile-personalInfoContainerTitle"
                    >
                        {{ $t('personal-account.profile.personal-info.title') }}
                    </h3>
                    <div class=" row">
                        <div class=" col col-12 col-lg-6">
                            <InputFieldWithLabel
                                :value="profile.firstName.value"
                                data-cy="input.firstName"
                                :label="$t('personal-account.profile.personal-info.firstName')"
                                :isRequired="true"
                                :errorLabel="getError(profile.firstName.errors)"
                                @input="(value) => updateProfile('firstName.value', value)"
                            />
                        </div>
                        <div class=" col col-12 col-lg-6">
                            <InputFieldWithLabel
                                :value="profile.lastName.value"
                                data-cy="input.lastName"
                                :label="$t('personal-account.profile.personal-info.lastName')"
                                :isRequired="true"
                                :errorLabel="getError(profile.lastName.errors)"
                                @input="(value) => updateProfile('lastName.value', value)"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div
                            class=" col col-12 col-lg-6 Profile-personalInfoContainerCol--pointer"
                            data-cy="div.address-click"
                            @click="$router.push({name:'personalAccountAddress'})"
                            @keyup.enter="$router.push({name:'personalAccountAddress'})"
                        >
                            <div class="Profile-personalInfoAddressMask" />
                            <InputFieldWithLabel
                                data-cy="input.address"
                                :value="profile.address.value"
                                :label="$t('personal-account.profile.personal-info.address')"
                            />
                        </div>
                        <div class=" col col-12 col-lg-6">
                            <InputPhoneNumber
                                v-if="profileLoaded"
                                v-model="phoneNumber"
                                :lang="profile.phoneNumber.country"
                                data-cy="input.phoneNumber"
                                @update="updatePhoneNumber"
                            />
                        </div>
                    </div>
                    <div class=" row">
                        <div class=" col col-12 col-lg-6">
                            <InputFieldWithLabel
                                :value="profile.email.value"
                                data-cy="input.email"
                                :label="$t('personal-account.profile.personal-info.email')"
                                :disabled="true"
                                :readonly="true"
                                class="Profile-inputDisabled"
                            />
                        </div>
                    </div>
                    <div
                        v-if="global.errors.length > 0"
                        class="row"
                    >
                        <div class="col col-12">
                            <Message
                                type="error"
                            >
                                <div class="Profile-formError">
                                    <span class="f2m-warning-circle" />
                                    {{ getError(global.errors) }}
                                </div>
                            </Message>
                        </div>
                    </div>
                    <div class=" row">
                        <div class="Profile-personalInfoSubmitContainer col col-12 col-lg-6">
                            <RoundedButton
                                class="Profile-submitButtom"
                                :label="$t('personal-account.profile.personal-info.save')"
                                type="reversed"
                                data-cy="button.submit"
                                @buttonClicked="submit"
                            />
                        </div>
                    </div>
                </Block>
            </div>
            <!--            <div class="Profile-documentsContainer">-->
            <!--                <div-->
            <!--                    v-for="(row, rowIndex) in documentRows"-->
            <!--                    :key="rowIndex"-->
            <!--                    class="row"-->
            <!--                >-->
            <!--                    <div-->
            <!--                        v-for="(document, docIndex) in row"-->
            <!--                        :key="docIndex"-->
            <!--                        class="col col-12 col-lg-6"-->
            <!--                    >-->
            <!--                        <SupportingDocument-->
            <!--                            :document="document"-->
            <!--                        />-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
        </div>
    </Transition>
</template>

<script>
// import ProgressBar from '@/components/ProgressBar.vue';
// import ServiceAvailability from '@/components/ServiceAvailability.vue';
import {
    Block, InputFieldWithLabel, InputPhoneNumber, RoundedButton, Message
} from '@free2move/vuejs-components';
import PageTitle from '@/components/PageTitle.vue';
import {GET_PROFILE, GET_SUPPORTING_DOCUMENTS} from "@/store/action-types";
import {validate} from "@free2move/vuejs-components/validators.js";
import * as mutationTypes from "@/store/mutation-types";
import * as actionTypes from "@/store/action-types";
// import SupportingDocument from '@/components/SupportingDocument.vue';
import {phone} from 'phone';
import Component from "vue-class-component";
import Vue from "vue";
import {mapState} from "vuex";

@Component({
    computed: {
        ...mapState(['profile'])
    },
    components: {
        // ProgressBar,
        // ServiceAvailability,
        PageTitle,
        Block,
        InputFieldWithLabel,
        InputPhoneNumber,
        RoundedButton,
        // SupportingDocument,
        Message
    }
})
export default class Profile extends Vue {
    data() {
        return {
            country: this.$country,
            profileLoaded: false,
            documents: [],
            global: {
                errors: []
            },
            phoneNumber: '',
            isLoaded: false
        }
    }

    mounted() {
        this.getProfile()
    }

    get currentValue() {
        return {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    }
    get documentRows() {
        let rows = [];
        let row = [];
        this.documents.forEach((document, index) => {
            row.push(document);
            if (index % 2 === 1) {
                rows.push(row);
                row = [];
            }
        });
        if (row.length > 0) {
            rows.push(row);
        }
        return rows;
    }

    getProfile() {
        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
        if (!this.profile.profileLoaded) {
            this.$store.dispatch(GET_PROFILE, {
                callback: (response) => {
                    if (response.data) {
                        this.updateProfile('firstName.value', response.data.firstName);
                        this.updateProfile('lastName.value', response.data.lastName);
                        this.updateProfile('phoneNumber.value', response.data.phoneNumber);
                        this.phoneNumber = response.data.phoneNumber;
                        this.updateProfile('phoneNumber.country', this.getPhoneCountry(response.data.phoneNumber));
                        this.updateProfile('address.value', response.data.address?.formatted?.join(' ') || '');
                        this.updateProfile('email.value', response.data.email);
                        this.updateProfile('profileLoaded', true);
                        this.profileLoaded = true;
                    }
                    this.$store.dispatch(GET_SUPPORTING_DOCUMENTS, {
                        callback: (docResponse) => {
                            this.setDocuments(docResponse)
                            this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
                            this.isLoaded = true;
                        }
                    });
                }
            });
        } else {
            this.profileLoaded = this.profile.profileLoaded;
            this.phoneNumber = this.profile.phoneNumber.value;
            this.$store.dispatch(GET_SUPPORTING_DOCUMENTS, {
                callback: (docResponse) => {
                    this.setDocuments(docResponse)
                    this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
                    this.isLoaded = true;
                }
            });
        }

    }
    getPhoneCountry(phoneNumber) {
        return phone(phoneNumber)?.countryIso2 || this.$country;
    }

    getPhoneValue(phoneNumber) {
        return phoneNumber?.replace(phone(phoneNumber)?.countryCode, '') || '';
    }
    setDocuments(response) {
        this.documents = response.data;
    }
    submit() {
        this.resetErrors();
        validate({
            firstName: this.profile.firstName,
            lastName: this.profile.lastName,
            phoneNumber: this.profile.phoneNumber,
        })
            .then(() => {
                this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
                this.$store.dispatch(actionTypes.UPDATE_USER_PROFILE, {
                    data: {
                        firstName: this.profile.firstName.value,
                        lastName: this.profile.lastName.value,
                        phoneNumber: this.profile.phoneNumber.value,
                    },
                    callback: ({data}) => {
                        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
                        if (!data) {
                            this.global.errors.push('anErrorOccurred');
                        }
                    }
                })
            })
            .catch((errors)=>{
                this.profile.firstName.errors = errors.firstName;
                this.profile.lastName.errors = errors.lastName;
                this.profile.phoneNumber.errors = errors.phoneNumber;
            })
            .finally(()=>{
                this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
            });
    }
    getError(errors) {
        return errors?.length > 0 ? this.$t('personal-account.profile.error.' + errors[0]) : ''
    }
    resetErrors() {
        this.profile.firstName.errors = [];
        this.profile.lastName.errors = [];
        this.profile.phoneNumber.errors = [];
        this.global.errors = [];
    }
    updatePhoneNumber(payload) {
        this.updateProfile('phoneNumber.value', payload.formattedNumber);
        this.updateProfile('phoneNumber.country', payload.countryCode);
    }

    updateProfile(key, value) {
        this.$store.commit(mutationTypes.UPDATE_PROFILE, {key, value});
    }
}
</script>

<style lang="scss" scoped>
.Profile{
    width: 100%;

    @media (max-width: $f2m-desktop-breakpoint) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: calc(100vh - 150px);
        position: relative;
    }

    &-progressBar{
        width: 300px;
    }
    &-serviceAvailability{
        margin-top: 20px;
    }

    &-personalInfoContainer{
        margin-top: 36px;
        margin-bottom: 56px;
    }

    &-personalInfoContainerBlock{
        padding: 28px;
        @media only screen and (max-width: $f2m-desktop-breakpoint) {
            padding: 20px;
        }
    }

    &-personalInfoContainerTitle{
        color: $color-f2m-purple;
        font-size: 22px;
        font-weight: 400;
        margin: 0;
        margin-bottom: 36px;
    }

    .col{
        margin-bottom: 28px;
    }

    &-personalInfoContainerCol {
        width: 47%;
        margin: 0 0 28px;
        padding: 0;

        &--pointer {
            cursor: pointer;
        }
    }
    &-personalInfoAddressMask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        z-index: 1;
        cursor: pointer;
    }

    &-personalInfoContainerFull {
        width: 100%;
    }

    &-personalInfoSubmitContainer.col{
        margin-bottom: 0;
    }

    &-personalInfoSubmit {
        width: 100%;
        @media (min-width: $f2m-desktop-breakpoint) {
            max-width: 420px
        }
    }

    &-formError {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
    }

    &-inputDisabled {
        background: #F3F2F9;
        border-radius: 10px;
    }

    &-submitButtom.RoundedButton{
        width: 100%;
    }
}
</style>
